import { f7 } from 'framework7-vue';
import Api from './ApiContracts';
import Contracts from './Contracts';
import Crops from './Crops';
import Farmers from './Farmers';
import Fields from './Fields';

const syncData = async () => {
  // eslint-disable-next-line no-console
  console.log('sync->syncData');

  await Farmers.syncPendingFarmers();
  await Fields.syncPendingFields();
  await Crops.syncPendingCrops();
  await Contracts.syncPendingContracts();
};

/* Posibles errores para tener en cuenta a futuro */
/* la parte de obtener variedades de artculos no funciona por que el procedimiento no cumplia con la segunda condicion que se debe
configurar en cada cliente, en el procedimiento debemos poner el 2 que es el tipo de productos articulos ,
cuando no le pasamos un tipo de variedad al nuevo cultivo da error en la sincronizacion y en contratos pasa lo mismo
AppContratos_ObtenerVariedades -> procedimineto que hay que revisar en caso de error */
const syncMasterData = async () => {
  await Api.syncMasterData();
  await Api.syncEntitiesData();

  // Eliminamos todas las fincas con codigo 0 poq ya se autogenero en el back
};

export default {
  async ForceSync(showPreloader) {
    try {
      if (showPreloader) {
        f7.preloader.show();
      }
      await syncData();
      await syncMasterData();
      if (showPreloader) {
        f7.preloader.hide();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error en la sincronización: ${error}`);
    }
  },

  /**
   * Returns the set of tasks to be synchronised.
   * Structured to be processed and displayed in a generic way.
   * @returns pendingTasksSync
   */
  async GetTasksSync() {
    async function loadFarmer(id) {
      const farmer = await Farmers.getFarmersFullInfo([id]);
      if (farmer == null || farmer.length === 0) {
        return null;
      }
      return farmer[0];
    }
    const tasksSync = [];
    const syncFarmers = await Farmers.getAllSyncPending();
    tasksSync.splice(0, 1);
    tasksSync.unshift({
      key: 'farmers',
      name: 'Agricultores',
      status: syncFarmers.length > 0 ? 'ko' : 'ok',
      items: syncFarmers,
    });
    const syncFields = await Fields.getAllSyncPending();
    tasksSync.splice(1, 1);
    tasksSync.unshift({
      key: 'fields',
      name: 'Fincas',
      status: syncFields.length > 0 ? 'ko' : 'ok',
      items: syncFields,
      route: '/new-field/',
    });
    const syncCrops = await Crops.getAllSyncPending();
    // Load FarmerInfo
    syncCrops.forEach(async (e) => {
      e.field.farmer = await loadFarmer(e.field.farmer);
    });
    tasksSync.splice(2, 1);
    tasksSync.unshift({
      key: 'crops',
      name: 'Cultivos',
      status: syncCrops.length > 0 ? 'ko' : 'ok',
      items: syncCrops,
      route: '/new-crop/',
    });
    const syncContracts = await Contracts.getAllSyncPending();
    tasksSync.splice(3, 1);
    tasksSync.unshift({
      key: 'contracts',
      name: 'Contratos',
      status: syncContracts.length > 0 ? 'ko' : 'ok',
      items: syncContracts,
      route: '/new-contract/',
    });
    return tasksSync;
  },
  /**
   * this method returns true if there are pending synchronisations.
   * @returns syncPending
   */
  async GetStatusSync() {
    const tasksSync = await this.GetTasksSync();
    if (tasksSync.filter((f) => f.status === 'ko').length > 0) {
      return true;
    }
    return false;
  },
};
